__webpack_require__.p = "/static/en-IT/infographics/just-transition/";